import styled from "styled-components";
import {Upload} from 'antd';

import 'antd/lib/upload/style';

export const UploadStyle = styled(Upload)`
    .ant-upload {
        margin: 20px;
    }
`;